var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"title":_vm.title,"items":_vm.items,"alertVisible":false}},[_c('div',{staticClass:"page-content"},[_c('CrudTable',{attrs:{"name":_vm.name,"table":_vm.table,"fields":_vm.fields,"filter":_vm.filter,"include":_vm.include,"showBtnNew":_vm.showBtnNew,"tooltip":_vm.tooltip}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }